import { ChallengeService } from '@duck/api-definitions'
import { TranslationKey } from '@/modules'

export const feedbackStatusTranslationMap: Record<ChallengeService.FeedbackStatusEnum, TranslationKey> = {
  [ChallengeService.FeedbackStatusEnum.Unprocessed]: 'challenges.pendingFeedback',
  [ChallengeService.FeedbackStatusEnum.Processing1]: 'challenges.processingStage1',
  [ChallengeService.FeedbackStatusEnum.Processing2]: 'challenges.processingStage2',
  [ChallengeService.FeedbackStatusEnum.Processing3]: 'challenges.processingStage3',
  [ChallengeService.FeedbackStatusEnum.Processing4]: 'challenges.processingStage4',
  [ChallengeService.FeedbackStatusEnum.Processing5]: 'challenges.processingStage5',
  [ChallengeService.FeedbackStatusEnum.Processing6]: 'challenges.processingStage6',
  [ChallengeService.FeedbackStatusEnum.Processing7]: 'challenges.processingStage7',
  [ChallengeService.FeedbackStatusEnum.Processing8]: 'challenges.processingStage8',
  [ChallengeService.FeedbackStatusEnum.Processing9]: 'challenges.processingStage9',
  [ChallengeService.FeedbackStatusEnum.Processing10]: 'challenges.processingStage10',
  [ChallengeService.FeedbackStatusEnum.Processing11]: 'challenges.processingStage11',
  [ChallengeService.FeedbackStatusEnum.Processing12]: 'challenges.processingStage12',
  [ChallengeService.FeedbackStatusEnum.Processing13]: 'challenges.processingStage13',
  [ChallengeService.FeedbackStatusEnum.Processing14]: 'challenges.processingStage14',
  [ChallengeService.FeedbackStatusEnum.Processing15]: 'challenges.processingStage15',
  [ChallengeService.FeedbackStatusEnum.Processed]: 'challenges.processingStageReady',
}